import React from 'react';
import SidebarParametres from '../../../layout/SidebarParametres';
import { useOAD } from '../../../layout/OADLayout';
import SelecteurProduction, {
  productionParDefaut,
} from '../../shared/components/SelecteurProduction';

/**
 * Unitaire
 *
 * Fil de fer (Phase 1) : la navigation est câblée, le contenu arrive en
 * Phase 6.
 * Contenu prévu : port Shiny onglet 'Besoin journalier', mock
 */
export default function Unitaire() {
  const { idExploit } = useOAD();
  const [production, setProduction] = React.useState(productionParDefaut);

  return (
    <div className="oad-contenu">
      <SidebarParametres
        niveau1="2026-2027"
        niveau2="eau-3-mois"
        niveau3="unitaire"
        idExploit={idExploit}
      >
        <SelecteurProduction valeur={production} onChange={setProduction} />
      </SidebarParametres>
      <main className="oad-cards">
        <div className="oad-card oad-card-placeholder">
          <h2>Unitaire</h2>
          <p>port Shiny onglet 'Besoin journalier', mock</p>
        </div>
      </main>
    </div>
  );
}
